import { render, staticRenderFns } from "./InstrumentContent.vue?vue&type=template&id=83331f34&scoped=true&"
import script from "./InstrumentContent.vue?vue&type=script&lang=ts&"
export * from "./InstrumentContent.vue?vue&type=script&lang=ts&"
import style0 from "./InstrumentContent.vue?vue&type=style&index=0&id=83331f34&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83331f34",
  null
  
)

export default component.exports